import { onChangeAnswer, onRemoveAnswer } from "./answer";
import { onPreviousQuestion, onSubmitQuestion } from "./question";
import { onResetQuiz } from "./quiz";

const reducer = (state, action) => {
  if (state.completed) return state;

  switch (action.type) {
    case "CHANGE_ANSWER":
      return onChangeAnswer(state, action);

    case "REMOVE_ANSWER":
      return onRemoveAnswer(state, action);

    case "SUBMIT_QUESTION":
      return onSubmitQuestion(state, action);

    case "PREVIOUS_QUESTION":
      return onPreviousQuestion(state, action);

    case "RESET_QUIZ":
      return onResetQuiz(state, action);

    default:
      return state;
  }
};

export default reducer;
